import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import Spacing from "../Spacing";

export default function FidelisMessageBarChart({ totalMessageSent }) {
  const [chartData, setChartData] = useState({ series: [], options: {} });

  const sortedEntries = useMemo(() => {
    if (!totalMessageSent) return [];
    return Object.entries(totalMessageSent).sort((a, b) => b[1] - a[1]);
  }, [totalMessageSent]);

  useEffect(() => {
    if (sortedEntries.length > 0) {
      const categoriesData = sortedEntries.map(([loc]) => loc);
      const seriesData = sortedEntries.map(([, val]) => val);

      const maxVal = Math.max(...seriesData);
      const paddedMax = Math.ceil(maxVal * 1.08);

      const newOptions = {
        chart: {
          type: "bar",
          toolbar: { show: false },
          animations: { enabled: true },
          parentHeightOffset: 0,
        },
        title: {
          show: false
        },

        grid: {
          show: false,
          padding: { left: 0, right: 8, top: 8, bottom: 0 },
        },

        colors: ["#5EB0EF"],

        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "70%",
            borderRadius: 4,
            borderRadiusApplication: "end",
            borderRadiusWhenStacked: "last",
            distributed: false,
            dataLabels: { position: "top" },
          },
        },

        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}`,
          style: { fontSize: "12px", fontWeight: 600, colors: ["#ffffff"] },
          dropShadow: { enabled: false },
          textAnchor: "end",
          offsetX: -8,
          background: { enabled: false },
          hideOverflowingLabels: false,
        },

        xaxis: {
          categories: categoriesData,
          min: 0,
          max: paddedMax,
          tickAmount: 7,
          labels: {
            style: { colors: "#817F8B", fontSize: "12px" },
            formatter: (val) => Math.round(val),
          },
          axisBorder: {
            show: true, color: "#E5E7EB", height: 1, offsetX: 0, offsetY: 0,
          },
          axisTicks: { show: false },
        },

        yaxis: {
          axisBorder: { show: true, color: "#E5E7EB", width: 1, offsetX: 0 },
          axisTicks: { show: false },
          labels: {
            style: { colors: "#4B5563", fontSize: "12px" },
            trim: false, 
            maxWidth: 2000,
            offsetX: 0,
          },
        },

        tooltip: {
          y: { formatter: (val) => `${val}` },
        },

        legend: { show: false },
      };

      setChartData({
        series: [{ name: "Send Message", data: seriesData }],
        options: newOptions,
      });
    }
  }, [sortedEntries]);

  const chartHeight = Math.max(280, sortedEntries.length * 46);

  return (
    <div className="docpro_chart">
      {sortedEntries.length > 0 ? (
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={chartHeight}
        />
      ) : (
        <Spacing lg="20" sm="20" />
      )}
    </div>
  );
}
